import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CTCandidate() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-745">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-746">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-747">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-748">
            Be CONFIDENT
          </span>

          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-749">
            AM I A GOOD CANDIDATE?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-750"></div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-751">
            <p data-id="element-752">
              CoolTone is suitable for individuals looking to enhance muscle
              definition in their abdomen, buttocks, or thighs. Ideal candidates
              typically have a healthy BMI, some degree of subcutaneous adipose
              tissue, and existing muscle tone. While some patients may see
              improvement after a single treatment, most will require a series
              of four sessions over a month to achieve their desired results.
            </p>
            <p data-id="element-753">
              CoolSculpting permanently reduces fat cells in treated areas, and
              once these fat cells are eliminated from the body, they do not
              return. However, maintaining a stable weight and healthy lifestyle
              is essential to prevent remaining fat cells from expanding. As
              long as patients continue to engage in physical activity to keep
              their muscles active, the results of CoolTone can last.
            </p>
            <p data-id="element-754">
              During a CoolTone session, the device is positioned on the
              targeted area to deliver electromagnetic stimulation to the
              underlying muscles. Patients can remain comfortably seated or
              lying down throughout the procedure, which typically lasts about
              20 to 30 minutes.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}